// List of blocked personal email domains
const BLOCKED_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.ca',
  'yahoo.com.au',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.ca',
  'live.com',
  'live.co.uk',
  'live.ca',
  'outlook.com',
  'outlook.co.uk',
  'outlook.ca',
  'msn.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'protonmail.com',
  'proton.me',
  'tutanota.com',
  'yandex.com',
  'yandex.ru',
  'mail.ru',
  'rambler.ru',
  'zoho.com',
  'fastmail.com',
  'gmx.com',
  'gmx.de',
  'web.de',
  't-online.de',
  'freenet.de',
  'arcor.de',
  '1und1.de',
  'orange.fr',
  'wanadoo.fr',
  'free.fr',
  'laposte.net',
  'sfr.fr',
  'alice.it',
  'libero.it',
  'virgilio.it',
  'tiscali.it',
  'tin.it',
  'fastwebnet.it',
  'windtre.it',
  'tim.it',
  'vodafone.it',
  'telecom.it',
  'rediffmail.com',
  'sify.com',
  'indiatimes.com',
  'rediff.com',
  'in.com',
  'yahoo.co.in',
  'hotmail.co.in',
  'live.co.in',
  'outlook.co.in',
  'naver.com',
  'daum.net',
  'hanmail.net',
  'nate.com',
  'kakao.com',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'sohu.com',
  'tom.com',
  'yeah.net',
  'foxmail.com',
  '139.com',
  '189.cn',
  'aliyun.com',
  'tencent.com',
  'baidu.com',
  'sogou.com',
  '360.cn',
  '21cn.com',
  'vip.qq.com',
  'vip.163.com',
  'vip.126.com',
  'vip.sina.com',
  'vip.sohu.com',
  'vip.tom.com',
  'vip.yeah.net',
  'vip.foxmail.com',
  'vip.139.com',
  'vip.189.cn',
  'vip.aliyun.com',
  'vip.tencent.com',
  'vip.baidu.com',
  'vip.sogou.com',
  'vip.360.cn',
  'vip.21cn.com'
];

// Common business/corporate email patterns that are allowed
const ALLOWED_PATTERNS = [
  // Generic business patterns
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
];

/**
 * Validates if an email address is from a business/corporate domain
 * @param email - The email address to validate
 * @returns Object with isValid boolean and error message
 */
export const validateBusinessEmail = (email: string): { isValid: boolean; error?: string } => {
  if (!email) {
    return { isValid: false, error: 'Email is required' };
  }

  // Basic email format validation
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }

  // Extract domain from email
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) {
    return { isValid: false, error: 'Invalid email format' };
  }

  // Check if domain is in blocked list
  if (BLOCKED_DOMAINS.includes(domain)) {
    return { 
      isValid: false, 
      error: 'Please use your business email address. Personal email providers (Gmail, Yahoo, etc.) are not accepted.' 
    };
  }

  // Additional validation for common business patterns
  const isBusinessEmail = ALLOWED_PATTERNS.some(pattern => pattern.test(email));
  
  if (!isBusinessEmail) {
    return { 
      isValid: false, 
      error: 'Please use a valid business email address' 
    };
  }

  return { isValid: true };
};

/**
 * Gets a list of blocked domains for display purposes
 */
export const getBlockedDomains = (): string[] => {
  return [...BLOCKED_DOMAINS];
};

/**
 * Checks if a domain is blocked
 */
export const isDomainBlocked = (domain: string): boolean => {
  return BLOCKED_DOMAINS.includes(domain.toLowerCase());
};
